import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { businessInfo } from '../../data/mock';
import { Button } from '../ui/button';

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About' },
    { path: '/testimonials', label: 'Testimonials' },
    { path: '/faq', label: 'FAQ' },
    { path: '/contact', label: 'Contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-slate-100">
      {/* Top bar */}
      <div className="bg-navy text-white py-2 px-4">
        <div className="max-w-7xl mx-auto flex justify-end items-center gap-6 text-sm">
          <a href={`tel:${businessInfo.phone}`} className="flex items-center gap-2 hover:text-amber transition-colors">
            <Phone size={14} />
            <span>{businessInfo.phone}</span>
          </a>
          <a href={`mailto:${businessInfo.email}`} className="flex items-center gap-2 hover:text-amber transition-colors">
            <Mail size={14} />
            <span>{businessInfo.email}</span>
          </a>
        </div>
      </div>
      
      {/* Main nav */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img 
              src={businessInfo.logo} 
              alt={businessInfo.name} 
              className="h-16 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors hover:text-teal ${
                  isActive(link.path) ? 'text-teal' : 'text-navy'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact">
              <Button className="bg-amber hover:bg-amber-dark text-navy font-semibold px-6">
                Get in Touch
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            className="lg:hidden p-2 text-navy"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden pb-6 border-t border-slate-100">
            <div className="flex flex-col gap-4 pt-4">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-base font-medium transition-colors px-2 py-2 rounded hover:bg-slate-50 ${
                    isActive(link.path) ? 'text-teal' : 'text-navy'
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsMenuOpen(false)}>
                <Button className="w-full bg-amber hover:bg-amber-dark text-navy font-semibold mt-2">
                  Get in Touch
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
